import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  CircularProgress,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import Navigation from "../RootNavigation";
import Footer from "../Footer";
import api from "../api/api";
import { ENDPOINTS } from "../api/endpoints";

export default function ForgotUsername() {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    setMessage("");
    setError("");

    try {
      const response = await api.post(
        ENDPOINTS.forgotUsername(),
        {
          email: email,
        }
      );

      const res = response.data;

      if (res?.httpStatusCode === 200) {
        setMessage("Username retrieval email sent successfully.");
      } else {
        setError(res?.message || "Something went wrong.");
      }
    } catch (err) {
      console.error(err);
      setError("Unable to connect. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Navigation />

      <Box
        sx={{
          minHeight: "80vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          px: 2,
        }}
      >
        <Box
          sx={{
            width: "100%",
            maxWidth: 450,
            p: 4,
            borderRadius: 2,
            boxShadow: 3,
            backgroundColor: "#fff",
          }}
        >
          <Typography
            variant="h4"
            textAlign="center"
            sx={{ mb: 3, fontWeight: 600 }}
          >
            Forgot Username
          </Typography>

          <form onSubmit={handleSubmit}>
            <TextField
              fullWidth
              label="Email Address"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              margin="normal"
            />

            {message && (
              <Typography color="success.main" sx={{ mt: 1 }}>
                {message}
              </Typography>
            )}

            {error && (
              <Typography color="error" sx={{ mt: 1 }}>
                {error}
              </Typography>
            )}

            <Button
              type="submit"
              fullWidth
              variant="contained"
              disabled={loading}
              sx={{
                mt: 3,
                backgroundColor: "#90b5fe",
                "&:hover": {
                  backgroundColor: "#202020",
                },
              }}
            >
              {loading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                "Submit"
              )}
            </Button>

            <Button
              fullWidth
              variant="text"
              sx={{ mt: 2 }}
              onClick={() => navigate("/login")}
            >
              Back to Login
            </Button>
          </form>
        </Box>
      </Box>

      <Footer />
    </>
  );
}   